import { render, staticRenderFns } from "./LoadTotal.vue?vue&type=template&id=3c7034fa&"
import script from "./LoadTotal.vue?vue&type=script&lang=js&"
export * from "./LoadTotal.vue?vue&type=script&lang=js&"
import style0 from "./LoadTotal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports